import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["disabledConcurrencyResourcesGetList", "disabledConcurrencyResourcesGetOne"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { all, takeLatest, takeEvery, cancel, fork, take } from 'redux-saga/effects';
import { crudActions, serialCrudActions } from './sagas';
import addressBackup from './addressBackup';
import suggestionsViaBackend from './suggestionsViaBackend';
import { // DELETE_MANY_WITH_DELAY,
SEARCH_ADDRESS, REVERSE_ADDRESS, SUGGEST_SEARCH, SEARCH_ADDRESS_BACKUP, REVERSE_ADDRESS_BACKUP, restActions, GET_LIST, GET_ONE, SUGGEST_SEARCH_VIA_BACKEND } from '../actions/constants';
import { SERIAL_CRUD_ACTIONS } from '../actions/serial';
import { throttleWithCancel } from '../utils/saga';

var takeLatestCustom = function takeLatestCustom(getTaskPatternForAction) {
  return function (pattern, saga) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return fork( /*#__PURE__*/_regeneratorRuntime.mark(function gen() {
      var lastTask, _action;

      return _regeneratorRuntime.wrap(function gen$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            lastTask = {};

          case 1:
            if (!true) {
              _context.next = 13;
              break;
            }

            _context.next = 4;
            return take(pattern);

          case 4:
            _action = _context.sent;

            if (!lastTask[getTaskPatternForAction(_action)]) {
              _context.next = 8;
              break;
            }

            _context.next = 8;
            return cancel(lastTask[getTaskPatternForAction(_action)]);

          case 8:
            _context.next = 10;
            return fork.apply(void 0, [saga].concat(_toConsumableArray(args.concat(_action))));

          case 10:
            lastTask[getTaskPatternForAction(_action)] = _context.sent;
            _context.next = 1;
            break;

          case 13:
          case "end":
            return _context.stop();
        }
      }, gen);
    }));
  };
};

export default (function (rest) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _options$disabledConc = options.disabledConcurrencyResourcesGetList,
      disabledConcurrencyResourcesGetList = _options$disabledConc === void 0 ? [] : _options$disabledConc,
      _options$disabledConc2 = options.disabledConcurrencyResourcesGetOne,
      disabledConcurrencyResourcesGetOne = _options$disabledConc2 === void 0 ? [] : _options$disabledConc2,
      otherOptions = _objectWithoutProperties(options, _excluded);

  return /*#__PURE__*/_regeneratorRuntime.mark(function rootSaga() {
    var _rest$endpoints;

    return _regeneratorRuntime.wrap(function rootSaga$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([].concat(_toConsumableArray(restActions.map(function (action) {
            if ([SUGGEST_SEARCH, SEARCH_ADDRESS, REVERSE_ADDRESS].indexOf(action) >= 0) {
              return throttleWithCancel(700, action, crudActions, rest, otherOptions);
            } // @ts-ignore


            // @ts-ignore
            return takeEvery(action, crudActions, rest, otherOptions);
          })), _toConsumableArray(disabledConcurrencyResourcesGetList.map(function (_ref) {
            var name = _ref.name,
                getTaskPatternForGetListAction = _ref.getTaskPatternForGetListAction;
            return (getTaskPatternForGetListAction ? takeLatestCustom(getTaskPatternForGetListAction) : takeLatest)("".concat(GET_LIST, "/").concat(name), crudActions, rest, otherOptions);
          })), _toConsumableArray(disabledConcurrencyResourcesGetOne.map(function (_ref2) {
            var name = _ref2.name;
            return (// @ts-ignore
              takeLatest("".concat(GET_ONE, "/").concat(name), crudActions, rest, otherOptions)
            );
          })), [takeLatest(SEARCH_ADDRESS_BACKUP, addressBackup, rest), takeLatest(REVERSE_ADDRESS_BACKUP, addressBackup, rest), // takeEvery(SERIAL_CRUD_ACTIONS, serialCrudActions, rest),
          // @ts-ignore
          takeEvery(SERIAL_CRUD_ACTIONS, serialCrudActions, rest, otherOptions), throttleWithCancel(700, SUGGEST_SEARCH_VIA_BACKEND, suggestionsViaBackend, rest === null || rest === void 0 || (_rest$endpoints = rest.endpoints) === null || _rest$endpoints === void 0 ? void 0 : _rest$endpoints.algolia)]));

        case 2:
        case "end":
          return _context2.stop();
      }
    }, rootSaga);
  });
});
//# sourceMappingURL=crud.js.map